import providerDropBoxTemplate from "templates/liveTV/providerSearch/_providerDropBox.tpl";

export default class TVProviderDropBox {

    constructor(parentContainer, data) {
        this.parentContainer = parentContainer;
        /**
         * @type {Array.<TVProvider>}
         */
        this.data = data;

        this.onProviderSelectedCallback = null;
        this.TVProvider = document.querySelector('div#provider__select__box');
        this.__createDropBox();
    }

    onProviderSelected(callback) {
        this.onProviderSelectedCallback = callback;
    }

    __createDropBox() {
        let temp = document.createElement('div');
        const providersList = this.__sortedProviders(this.data)
        temp.innerHTML = providerDropBoxTemplate({providers: providersList});
        let div = temp.querySelector('div');
        this.me = this.parentContainer.appendChild(div);
        this.filter = this.me.querySelector('span.filter');
        if (!this.filter) {
            this.filter = this.me.querySelector('button.filter');
        }
        this.__eventListeners();
    }
    __sortedProviders(data) {
        return data.sort((a, b) => {
            return a.providerName.toLowerCase().localeCompare(b.providerName.toLowerCase());
        });
    }
    __eventListeners() {
        // invoke the dropdown
        this.me.querySelector('li.pv-h').addEventListener('mouseenter', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.target.classList.add('hover');
            if (this.TVProvider) {
                this.filter.setAttribute('aria-expanded', 'true');
            }
        });

        // hide the dropdown
        this.me.querySelector('li.pv-h').addEventListener('mouseleave', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.target.classList.remove('hover', 'itemsListOpened');
            if (this.TVProvider) {
                this.filter.setAttribute('aria-expanded', 'false');
            }
        });

        // drop down items
        this.me.querySelectorAll('ul.provider__list__item li a').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                let providerId = e.target.dataset['providerid'];

                this.onProviderSelectedCallback(providerId);
                // trick dropdown to kill expand animation on tablet
                this.me.querySelector('li.pv-h').classList.remove('hover', 'itemsListOpened');
            });
        });

        // hide the dropdown after tab last list item
        this.me.querySelectorAll('ul.provider__list__item li a').forEach((el) => {
            el.addEventListener('blur', (e) => {
                try {
                    let nextListItem = e.relatedTarget.parentNode.nextElementSibling;
                    if (!nextListItem) {
                        // close items list
                        this.me.querySelector('li.pv-h')
                          .classList
                          .remove('hover', 'itemsListOpened');
                        if (this.TVProvider) {
                            this.filter.setAttribute('aria-expanded', 'false');
                        }

                        // remove tab index from list items
                        let itemsList = this.me.querySelector('li.pv-h ul').children;
                        Array.from(itemsList).forEach(item => {
                            item.firstChild.setAttribute("tabindex", '-1');
                        });
                    }
                } catch (e) {
                    return true;
                }
            });
        });

        // invoke the dropdown with using keyboard enter key
        this.me.querySelector('li.pv-h').addEventListener('keydown', (e) => {
            let keyCode = e.keyCode || e.which;
            let dropDown = this.me.querySelector('li.pv-h');

            // enter (13): display the list or click on the list item
            // tab (9): skip list or navigate through items list
            if (keyCode === 13) {
                const path = e.path || e.composedPath()
                if (!path) {
                    return
                }
                let currentElement = path[0]

                // manage a enter keydown on list item
                if (currentElement && currentElement.localName === 'a') {
                    currentElement.click();
                    return true;
                }

                e.preventDefault();
                e.stopPropagation();
                let itemsList = this.me.querySelector('li.pv-h ul').children;

                // show/hide dropdown
                if (dropDown.classList.contains('hover')) {
                    dropDown.classList.remove('hover', 'itemsListOpened');
                    if (this.TVProvider) {
                        this.filter.setAttribute('aria-expanded', 'false');
                    }
                    Array.from(itemsList).forEach(item => {
                        item.firstChild.setAttribute("tabindex", '-1');
                    });
                } else {
                    dropDown.classList.add('hover');
                    if (this.TVProvider) {
                        this.filter.setAttribute('aria-expanded', 'true');
                    }
                    Array.from(itemsList).forEach(item => {
                        item.firstChild.setAttribute("tabindex", '0');
                    });
                }
            } else if (keyCode === 9) {
                // navigate through list items
                if (dropDown.classList.contains('hover')) {
                    // give focus to the first list item element
                    if (!dropDown.classList.contains('itemsListOpened')) {
                        e.preventDefault();
                        e.stopPropagation();

                        // remove focus from root button
                        this.me.querySelector('li.pv-h span').blur();

                        // focus on the first list item
                        this.me.querySelector('li.pv-h a').focus();
                        dropDown.classList.add('itemsListOpened');
                    }
                }
            }
        });
    }
}
